import * as React from 'react';
import { useRecordContext } from 'react-admin';
import { 
    Box,
    Chip
} from "@mui/material";
import { EditComponent, CustomComponentProps, CreateComponent } from 'src/components/common/Component';
import Button from '@mui/material/Button';
import { useState } from 'react';
import { VerifyModal } from 'src/resources/user';
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";

export function UserEditComponent(props: CustomComponentProps) {
    const { children } = props;
    const record = useRecordContext();


    if (!record) return null;

    const PostEditActions = () => {
        const [openVerifyModal, setOpenVerifyModal] = useState(false);

        const setOpenVerifyModalHandler = (value: boolean) => {
            setOpenVerifyModal(value);
        }

        return ( 
            <>
            <Box marginY="10px" display="flex" gap="5px">
                { record?.verified ?
                    <Chip sx={{fontSize: "16px", padding: "8px 20px", height: "auto"}} label="Verified" color="primary" icon={<CheckOutlinedIcon sx={{width: "20px", height: "20px"}} />}/>
                :
                    <Button variant="contained" color="primary" onClick={()=>setOpenVerifyModalHandler(true)}>Verify User</Button>
                }
            </Box>

            {openVerifyModal &&
                <VerifyModal
                    open={openVerifyModal}
                    setOpen={setOpenVerifyModalHandler}
                    record={record}
                />
            }
            </>
        )
    }

    return (
        <EditComponent attributes={["first_name", "last_name"]} children={children} actions={<PostEditActions/>}/>
    );
}

export function UserCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"user"} children={children} />
    );
}